import React, { useEffect, useState } from 'react'
import { Text, Box, useToast, useColorModeValue } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const EmailDisplayer = ({ originalReversedEmail }) => {
    const { t } = useTranslation()

    const [email, setEmail] = useState(originalReversedEmail);
    const toast = useToast();

    useEffect(() => {
        const reversedEmail = email.split('').reverse().join('');
        setEmail(reversedEmail);
    }, []);

    const copyEmail = () => {
        navigator.clipboard.writeText(email).then(() => {
            toast({
                title: t('toast.email-copy.title'),
                description:t('toast.email-copy.description'),
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        }, (err) => {
            console.error('Could not copy text: ', err);
        });
    };

    return (
        <Box>
            <Text
                color={useColorModeValue('brand.blue', 'white')}
                _hover={{
                    color: useColorModeValue('brand.darkText', 'brand.blue')
                }}
                className="emailSpoof"
                fontWeight={'bold'}
                fontSize={'md'}
                direction="rtl"
                unicodeBidi="bidi-override"
                cursor="pointer"
                onClick={copyEmail}
            >
                {originalReversedEmail}
            </Text>
        </Box>
    );
};

export default EmailDisplayer;
